// mantine
import { Avatar } from '@mantine/core';
import { getIntegrationLogo } from '@/modules/Integrations/Integrations.utils.ts';
// assets
import styles from '@/modules/Integrations/components/ConnectorSelect/components/ConnectorPill/ConnectorPill.module.css';

interface ConnectorPillProps {
    value: string;
}

const ConnectorPill = ({ value }: ConnectorPillProps) => {
    const [integrationIdn, connectorIdn] = value.split('/');
    return (
        <div className={styles.pill}>
            <Avatar
                alt={integrationIdn}
                className="bg-gray-2"
                radius="xl"
                size="xs"
                src={getIntegrationLogo(integrationIdn)}
            >
                {integrationIdn.at(0)}
            </Avatar>
            {connectorIdn}
        </div>
    );
};

export default ConnectorPill;
